import imageCompression, { Options } from 'browser-image-compression'
import { SourceType } from '../../api/personas'
import { ContextByIdResponse } from '../../api/session'
import { MentorBase } from '../../types/mentor'
import { CarouselItem } from '../components/CarouselForm'

export const getId = (item: {
  sourceType: SourceType
  companion?: CarouselItem['companion']
  context?: CarouselItem['context']
}): string => {
  switch (item.sourceType) {
    case 'Companion':
      return item.companion?.id || ''
    case 'Context':
      return item.context?.id || ''
    default:
      return `banner-${Date.now()}`
  }
}

export const getNewEntry = (
  sourceType: SourceType,
  companion?: MentorBase,
  context?: ContextByIdResponse['data'],
  banner?: CarouselItem['banner'],
): CarouselItem => {
  const companionInfo = companion
    ? {
        id: companion?.mentorId || '',
        slug: companion?.slug || '',
        firstName: companion?.firstName || '',
        lastName: companion?.lastName || '',
        jobTitle: companion?.jobTitle || '',
        imageUrl: companion?.previewUrl || '',
        videoUrl: companion?.videoLoopUrl || '',
        hideJobTitle: true,
      }
    : undefined

  const contextInfo = context
    ? {
        id: context.id,
        header: context.clickbaitHeader || '',
        query: context.userQuery,
      }
    : undefined

  return {
    id: getId({
      sourceType,
      companion: companionInfo,
      context: contextInfo,
    }),
    title: context?.title || '',
    sourceType,
    visibility: 'admin',
    backgroundImageUrl: context?.imageUrl || '',
    backgroundVideoUrl: '',
    companion: companionInfo,
    context: contextInfo,
    isNewEntry: true,
    banner: banner,
  }
}

export const compressImage = async (
  file: File,
  maxSizeMB: number = 1,
): Promise<File> => {
  const options: Options = {
    maxSizeMB,
    useWebWorker: true,
    initialQuality: 0.8,
    alwaysKeepResolution: true,
  }

  try {
    const compressedFile = await imageCompression(file, options)
    return compressedFile
  } catch (error) {
    console.error('Image compression failed:', error)
    throw new Error('Image compression failed')
  }
}
